// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontFamilyValues } from "@guestsupply/XDL/constants";
import { color } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

export const createAccountStyles = css`
    .create-account-wrapper {
        .gs-div-section {
            padding: 8px;
            border: 1px solid ${color("common.ui3")};
            border-radius: 5px;
            margin-bottom: 20px;
        }
        input {
            width: 100%;
            padding: 10px;
        }
        .gs-div-section select,
        .gs-company-description {
            margin-left: 20px;
            font-size: smaller;
        }
        .gs-error {
            padding: 4px;
            color: ${color("primary")};
        }
        .gs-display-none {
            display: none;
        }
        .column,
        .columns {
            position: relative;
            padding-left: 16px;
            padding-right: 16px;
            float: left;
        }
        .large-6 {
            width: 50%;
        }
        .gs-child-container {
            padding: 4px;
            margin: 4px;
            border: solid 1px ${color("common.ui2")};
            border-radius: 5px;
            background-color: ${color("common.ui2")};
        }
        .gs-logo {
            max-width: 75%;
            margin: 0 auto;
        }
        .gs-text-center {
            text-align: center;
        }
        .gs-header {
            color: ${color("primary")};
            text-align: center;
        }

        .row {
            width: 100%;
            margin-left: auto;
            margin-right: auto;
            margin-top: 0;
            margin-bottom: 0;
        }
        .row:before,
        .row:after {
            content: " ";
            display: table;
        }
        .row:after {
            clear: both;
        }
        .row.collapse > .column,
        .row.collapse > .columns {
            padding-left: 0;
            padding-right: 0;
        }
        .row.collapse .row {
            margin-left: 0;
            margin-right: 0;
        }
        .row .row {
            width: auto;
            margin-left: -16px;
            margin-right: -16px;
            margin-top: 0;
            margin-bottom: 0;
            max-width: none;
        }
        .row .row:before,
        .row .row:after {
            content: " ";
            display: table;
        }
        .row .row:after {
            clear: both;
        }
        .row .row.collapse {
            width: auto;
            margin: 0;
            max-width: none;
        }
        .row .row.collapse:before,
        .row .row.collapse:after {
            content: " ";
            display: table;
        }
        .row .row.collapse:after {
            clear: both;
        }
        .text-center {
            text-align: center;
        }
        #btnSubmit {
            width: auto;
        }
        select {
            width: 100%;
            padding: 10px;
            margin-left: 0 !important;
        }
        a.btn {
            position: relative;
            border: 3px solid transparent;
            line-height: 16px;
            text-align: center;
            font-family: ${fontFamilyValues.GOTHAM};
            font-size: 16px;
            font-weight: bold;
            height: 40px;
            margin: 0;
            padding: 0 32px;
            white-space: nowrap;
            text-transform: uppercase;
            text-overflow: ellipsis;
            text-decoration: none;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            background-color: ${color("primary")};
            border-color: ${color("primary")};
            span {
                color: ${color("primary.contrast")} !important;
            }
        }
    }
`;
